import script from "./profileList.vue?vue&type=script&setup=true&lang=ts"
export * from "./profileList.vue?vue&type=script&setup=true&lang=ts"

import "./profileList.vue?vue&type=style&index=0&id=312ec4fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-312ec4fa"]])

export default __exports__